/**
 * Enum for integration type settings
 * Used to identify different integration categories
 */
export enum INTEGRATION_TYPE {
    SIGNATORY_SETTINGS = 'SIGNATORY_SETTINGS',
    SSO_SETTINGS = 'SSO_SETTINGS',
    DOCUMENT_PROCESSING_SETTINGS = 'DOCUMENT_PROCESSING_SETTINGS',
    EMAIL_INTEGRATION_SETTINGS = 'EMAIL_INTEGRATION_SETTINGS',
    MEETING_INTEGRATION_SETTINGS = 'MEETING_INTEGRATION_SETTINGS',
    CALENDAR_INTEGRATION_SETTINGS = 'CALENDAR_INTEGRATION_SETTINGS',
    SHEETS_INTEGRATION_SETTINGS = 'SHEETS_INTEGRATION_SETTINGS',
    DOCS_INTEGRATION_SETTINGS = 'DOCS_INTEGRATION_SETTINGS',
    SLIDES_INTEGRATION_SETTINGS = 'SLIDES_INTEGRATION_SETTINGS',
    TASKS_INTEGRATION_SETTINGS = 'TASKS_INTEGRATION_SETTINGS',
    STORAGE_INTEGRATION_SETTINGS = 'STORAGE_INTEGRATION_SETTINGS',
    DATABASE_INTEGRATION_SETTINGS = 'DATABASE_INTEGRATION_SETTINGS',
    BROWSER_INTEGRATION_SETTINGS = 'BROWSER_INTEGRATION_SETTINGS'
}

